(function () {
  /**
   * Add business days (Mon–Fri) to a date, skipping weekends.
   */
  function addBusinessDays(startDate, businessDays) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var added = 0;

    while (added < businessDays) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) {
        added += 1;
      }
    }

    return date;
  }

  /**
   * Estimated delivery date: 5 business days from today.
   */
  function getUtcDeliveryDate() {
    var deliveryDate = addBusinessDays(new Date(), 5);

    return deliveryDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  }

  function fillDeliveryDates(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var dateEls = scope.querySelectorAll
      ? scope.querySelectorAll('.dm-delivery-date, .delivery-date')
      : document.querySelectorAll('.dm-delivery-date, .delivery-date');

    if (!dateEls.length) return;

    var deliveryDate = getUtcDeliveryDate();

    dateEls.forEach(function (el) {
      el.textContent = deliveryDate;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fillDeliveryDates();
  });

  window.DMProductCards = {
    fillDeliveryDates: fillDeliveryDates,
    getUtcDeliveryDate: getUtcDeliveryDate
  };
})();
